<!--
  AtomicOrdersNotice.vue -- Phase 3.3 governed-edit inline notice.

  Card: 2026-06-13 design bundle implementation -- https://trello.com/c/hYlwyKYT
  Pebble: Phase 3.3 GovernedEditModal v1 update-everywhere.

  Reusable inline notice for the "Orders are atomic" guarantee per P3-Q8.
  First surface of three (modal); future surfaces: detail-page tooltip,
  hover surfaces elsewhere.

  Production copy (do not rephrase without product sign-off):

    "Editing artwork will not affect already-placed orders."

  (The leading "Orders are atomic --" was removed 2026-07-21, Jake:
  "atomic" is jargon store users don't understand. The plain sentence
  was then revised 2026-07-21 to the current wording, also Jake.)

  Visual treatment: amber/informational. The notice is a passive
  reassurance, NOT a warning -- the user is intentionally re-versioning;
  this confirms the safety floor.
-->
<template>
    <div
        class="atomic-orders-notice"
        :class="{ 'atomic-orders-notice--inline': inline }"
        data-testid="atomic-orders-notice"
        role="note"
    >
        <span
            class="atomic-orders-notice__icon"
            aria-hidden="true"
        >
            i
        </span>
        <span class="atomic-orders-notice__body">
            Editing artwork will not affect already-placed orders.
        </span>
    </div>
</template>

<script>
export default {
    name: 'AtomicOrdersNotice',
    props: {
        /**
         * When true, the notice renders inline (no top/bottom margin
         * + tighter padding) for use inside modal sections. Default
         * false -- the standalone variant has its own block margins.
         */
        inline: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.atomic-orders-notice {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    background: #fef3c7;
    border: 1px solid #fde68a;
    border-radius: 6px;
    color: #78350f;
    font-size: 13px;
    line-height: 1.5;
    margin: 12px 0;
}
.atomic-orders-notice--inline {
    margin: 0;
    padding: 10px 12px;
    font-size: 12px;
}
.atomic-orders-notice__icon {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #b45309;
    color: white;
    font-weight: 700;
    font-size: 11px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: 'Times New Roman', serif;
    line-height: 1;
}
.atomic-orders-notice__body {
    flex: 1 1 auto;
}
</style>
